import React from 'react';
import PropTypes from 'prop-types';
import './OverlayLoading.css';
import LoadingIndicator from '../loadingIndicator/LoadingIndicator';

const OverlayLoading = ({ loading }) => {
  if (!loading) {
    return null;
  }

  return (
    <div id="loading-container">
      <LoadingIndicator
        loading={loading}
      />
    </div>
  );
};

OverlayLoading.propTypes = {
  loading: PropTypes.bool,
};

OverlayLoading.defaultProps = {
  loading: true,
};

export default OverlayLoading;
